module.exports = __webpack_public_path__ + "img/isPro4_3.be12e22a.png";